import { SuperAdminConstants } from '../../../_constants';

const initialState = { editOrgDetailsLoading: true, data: '', error: false };

export function editOrgDetailsReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ORG_DETAILS:
            return {
                editOrgDetailsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ORG_DETAILS:
            return {
                editOrgDetailsLoading: false,
                data: action.editOrgDetails,
                error: false
            };
        case SuperAdminConstants.GET_ORG_DETAILS_ERROR:
            return {
                editOrgDetailsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/OrgDetails/editOrgDetails.reducer.js